<template lang="pug">
  BField#wt-readonly-input-controls
    WtLabel(
      slot="label"
      :label-for="label"
      :text="label"
      :tooltip-text="tooltipText"
    )
    BField(v-if="previewMode && !edit")
      BInput.control(
        :name="label"
        :readonly="previewMode && !edit"
        :value="previewValue ? trueValueText : falseValueText"
      )
      WtReadonlyInputControls.control(
        :edit="edit"
        @editActive="$event => edit = $event"
      )
    BField(v-if="!previewMode || edit")
      .control.is-size-6 {{ falseValueText }}
      BSwitch.control(
        :value="value"
        :true-value="trueValue"
        :false-value="falseValue",
        @input="handleInput"
        :disabled="disabled"
      )
      .control.is-size-6 {{ trueValueText }}
</template>

<script>
import WtLabel from "@@/WtLabel/WtLabel";
import WtReadonlyInputControls from "@@/WtReadonlyInputControls/WtReadonlyInputControls";

export default {
  name: "WtSwitchQuestionInput",

  components: { WtLabel, WtReadonlyInputControls },

  props: {
    label: {
      type: String,
      required: true
    },

    previewMode: {
      type: Boolean,
      default: false
    },

    previewValue: {
      type: Number,
      default: null
    },

    falseValueText: {
      type: String,
      default: "No"
    },

    trueValueText: {
      type: String,
      default: "Yes"
    },

    value: {
      type: [Number, String],
      default: 0
    },

    horizontal: {
      type: Boolean,
      default: false
    },

    trueValue: {
      type: [Number, String],
      default: 1
    },

    falseValue: {
      type: [Number, String],
      default: 0
    },

    tooltipText: {
      type: String,
      default: ""
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      edit: false
    };
  },

  computed: {
    horizontalClass() {
      return this.horizontal ? "horizontal" : "";
    }
  },

  watch: {
    previewValue() {
      if (this.previewMode) {
        this.edit = false;
      }
    }
  },

  methods: {
    handleInput(event) {
      this.$emit("input", event);
    }
  }
};
</script>

<style lang="sass" scoped></style>
